import { useTranslation } from 'react-i18next'
import { tourAnchor } from '~/helpers/tour/anchors'
import MonthPicker from '~/pages/backoffice/admin/billing/MonthPicker'

/** La règle de décompte et le mois observé, en tête des deux écrans de facturation. */
function BillingMonthHeader({ month, onChange }: { month: string, onChange: (month: string) => void }) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-wrap items-end justify-between gap-4" {...tourAnchor('billing.month')}>
      <p className="max-w-2xl text-sm text-muted-foreground">{t('billing.help')}</p>
      <MonthPicker value={month} onChange={onChange} />
    </div>
  )
}

export default BillingMonthHeader
